/**
 * API
 *
 * A simple wrapper for communicating with the API via ajax requests.
 */

import axios from 'axios'


const ROOT = process.env.NODE_ENV == 'production' ? 'https://api.nameql.com/' : 'http://localhost:8081/'


interface IOptions {
  base: string
  n: number
  sample: number
  filter?: string
}


export async function check(names: string[]): Promise<string[]> {
  let body = ''

  for (const name of names) {
    body += 'names[]=' + name + '&'
  }

  const res = await axios.post(ROOT + 'check', body)
  return res.data.taken
}


export async function suggest(options: IOptions): Promise<string[]> {
  try {
    const res = await axios.post(ROOT + 'suggest', urlEncode(options))
    return res.data.names
  } catch (e) {
    return []
  }
}


function urlEncode(object: Object): string {
  let str = ''

  for (let k in object) {
    const value = object[k]

    if (typeof value != 'undefined') {
      str += `&${k}=${object[k]}`
    }

  }

  return str.slice(1)
}


// WEBPACK FOOTER //
// ./src/service/api.ts